import { FloppyDiskIcon } from '@hugeicons/react'

import { useForm, FormProvider } from 'react-hook-form'

import { Button } from '@/shared/ui/Button'
import { Modal } from '@/shared/ui'
import { FormControl, InputGroup } from '@/shared/ui/Form'
import { QrCodeReader } from '@/shared/ui/QrCodeReader'

type QRCodeModalProps = {
  onHide: () => void
  onSave: (data: { content: string }) => void
}

export function QRCodeModal({ onHide, onSave }: QRCodeModalProps) {
  const methods = useForm<{ content: string }>()

  return (
    <Modal centered show onHide={onHide}>
      <Modal.Header onHide={onHide}>
        <Modal.Icon name="qrcode" className="text-brand" />
        <Modal.Title>Leia o QRCode</Modal.Title>
      </Modal.Header>
      <Modal.Body
        className="pt-0 pb-20"
        noPaddings={false}
        customPaddings={false}
      >
        <div className="max-w-[400px] mx-auto">
          <QrCodeReader
            onSuccess={content => onSave({ content })}
            className="bg-gray-200 rounded mb-4 overflow-hidden aspect-square"
            fallback={
              <>
                <span className="block font-bold text-center text-gray-700 mb-4">
                  Ou digite o código abaixo
                </span>
                <FormProvider {...methods}>
                  <form onSubmit={methods.handleSubmit(onSave)} className="grow">
                    <InputGroup solid={true}>
                      <FormControl name="content" solid required />
                      <Button
                        type="submit"
                        variant="primary"
                        showTrailingIcon={false}
                        className="w-10 shrink-0 !rounded-none !px-0"
                      >
                        <FloppyDiskIcon variant="duotone" size={24} />
                      </Button>
                    </InputGroup>
                  </form>
                </FormProvider>
              </>
            }
          />
        </div>
      </Modal.Body>
    </Modal>
  )
}
